/*
  Fuel First packs: one shared place for "what is in the default pack, what does it cost, and what is the lowest it can cost".
  Used by the pack builder (sections/pack-builder.liquid) and by pack cards on collection pages.
  Cards and the pack page price read "From" + the lowest price a customer can build from what is in stock.
*/
(function () {
  if (window.FFPack) { return; }

  // ---- products: single servings only, one entry per flavour ----
  function isSize(s) { return /single|unit|sachet|pack|bag|serving|box|tub|\d\s*x|\d+s$|\d+\s*g\b|\d+\s*ml\b/i.test(s); }
  function isSingle(s) { return /single|unit|sachet|serving|1\s*x\b/i.test(s); }

  function products(D) {
    var P = {};
    D.products.forEach(function (p) {
      if (!p || P[p.h]) { return; }
      var fl = [];
      p.vs.forEach(function (v) {
        var parts = v.t.split(' / '), name = v.t, ok = true;
        if (v.t === 'Default Title') { name = p.t; }
        else if (parts.length === 2) {
          var a = isSize(parts[0]), b = isSize(parts[1]);
          if (a && !b) { ok = isSingle(parts[0]); name = parts[1]; }
          else if (b && !a) { ok = isSingle(parts[1]); name = parts[0]; }
        } else if (parts.length === 1 && isSize(v.t)) { ok = isSingle(v.t); name = p.t; }
        if (ok) { fl.push({ id: v.id, name: name, price: v.p / 100, a: v.a, img: v.i || '' }); }
      });
      p.fl = fl.filter(function (f) { return f.a; });
      P[p.h] = p;
    });
    return P;
  }

  // ---- default picks: a mix of products and flavours ----
  function defaults(D, P) {
    var useP = {}, useF = {}, rows = [];
    D.slots.forEach(function (s) {
      // Interleave the groups (gel, chew, bar, gel, chew...) so the default is a mix of formats.
      var seenH = {}, out = [], g = s.groups || [], most = 0;
      g.forEach(function (x) { most = Math.max(most, x.length); });
      for (var k = 0; k < most; k++) { g.forEach(function (x) { var h = x[k]; if (h && !seenH[h]) { seenH[h] = 1; out.push(h); } }); }
      s.cands = out;
    });
    D.slots.forEach(function (s, si) {
      var cands = s.cands.filter(function (h) { return P[h] && P[h].fl.length; });
      for (var i = 0; i < s.qty; i++) {
        var h = null;
        if (!cands.length) { rows.push({ si: si, h: null, f: null, cands: [] }); continue; }
        var primary = s.cands[0];
        if (s.mode === 'fixed' && P[primary] && P[primary].fl.length) { h = primary; }
        else { h = cands.slice().sort(function (x, y) { return (useP[x] || 0) - (useP[y] || 0) || cands.indexOf(x) - cands.indexOf(y); })[0]; }
        useP[h] = (useP[h] || 0) + 1;
        // Least-used flavour first; caffeinated ones only once the plain ones have had a turn. Caffeine is a choice.
        var caf = function (x) { return /caff/i.test(x.name) ? 1 : 0; };
        var f = P[h].fl.slice().sort(function (x, y) { return ((useF[x.id] || 0) + caf(x) * 1.5) - ((useF[y.id] || 0) + caf(y) * 1.5); })[0];
        useF[f.id] = (useF[f.id] || 0) + 1;
        rows.push({ si: si, h: h, f: f.id, cands: cands });
      }
    });
    return rows;
  }

  function flav(P, r) { var p = P[r.h]; if (!p) { return null; } for (var i = 0; i < p.fl.length; i++) { if (p.fl[i].id === r.f) { return p.fl[i]; } } return p.fl[0]; }

  function total(P, rows) {
    var t = 0;
    rows.forEach(function (r) { var f = r.h ? flav(P, r) : null; if (f) { t += f.price; } });
    return t;
  }

  // ---- lowest possible pack price, within the pack builder's own rules ----
  // Normal lines: any product and flavour, repeats allowed, so every spot takes the cheapest single.
  // "No repeats" lines (taster packs): never the same flavour twice, and each product once
  // unless the line has more spots than products in stock.
  function lowest(D, P) {
    var usedP = {}, usedF = {}, t = 0;
    D.slots.forEach(function (s) {
      var seen = {}, cands = [];
      (s.groups || []).forEach(function (g) { g.forEach(function (h) { if (h && !seen[h] && P[h] && P[h].fl.length) { seen[h] = 1; cands.push(h); } }); });
      if (!cands.length) { return; }
      if (!s.unique) {
        var min = Infinity;
        cands.forEach(function (h) { P[h].fl.forEach(function (f) { if (f.price < min) { min = f.price; } }); });
        t += min * s.qty;
        return;
      }
      var needRepeat = s.qty > cands.length, opts = [], n = 0;
      cands.forEach(function (h) { P[h].fl.forEach(function (f) { opts.push({ h: h, f: f }); }); });
      opts.sort(function (a, b) { return a.f.price - b.f.price; });
      for (var i = 0; i < opts.length && n < s.qty; i++) {
        var o = opts[i];
        if (usedF[o.f.id] || (!needRepeat && usedP[o.h])) { continue; }
        usedP[o.h] = 1; usedF[o.f.id] = 1; t += o.f.price; n++;
      }
    });
    return Math.round(t * 100) / 100;
  }

  function money(n) {
    var s = n.toFixed(2).split('.');
    return 'R ' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1];
  }

  window.FFPack = { products: products, defaults: defaults, flav: flav, total: total, lowest: lowest, money: money };

  // ---- pack cards: replace the stored bundle price with "From" + the live lowest pack price ----
  // The pack builder section, rendered on its own, carries the recipe and live stock as JSON.
  // Its id changes when the theme is copied, so a working id found on a full pack page is remembered.
  // This default is the live theme's id (checked 2 Nov 2026). A wrong default costs every visit a failed request
  // plus a full page download, so update it after publishing a different theme copy.
  var SECTION_KEY = 'ff-pack-section';
  var SECTION = 'template--29072140730732__pack_builder';
  try { SECTION = sessionStorage.getItem(SECTION_KEY) || SECTION; } catch (e) {}
  var KEY = 'ff-pack-from:';
  var TTL = 10 * 60 * 1000;

  function readData(html, remember) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('[data-pb-data]');
    if (remember) {
      var sec = doc.querySelector('[id^="shopify-section-"][id$="__pack_builder"]');
      if (sec) { SECTION = sec.id.replace('shopify-section-', ''); try { sessionStorage.setItem(SECTION_KEY, SECTION); } catch (e) {} }
    }
    return el ? JSON.parse(el.textContent) : null;
  }
  function packFrom(url) {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY + url) || 'null');
      if (c && Date.now() - c.at < TTL) { return Promise.resolve(c.total); }
    } catch (e) {}
    var join = url.indexOf('?') > -1 ? '&' : '?';
    return fetch(url + join + 'section_id=' + SECTION)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var D = html ? readData(html) : null;
        if (D) { return D; }
        // Fallback (for example in a copied theme): read the full pack page, and remember its section id.
        return fetch(url).then(function (r) { return r.text(); }).then(function (h) { return readData(h, true); });
      })
      .then(function (D) {
        if (!D || !D.slots || !D.slots.length) { return null; }
        var t = lowest(D, products(D));
        if (!(t > 0)) { return null; }
        try { sessionStorage.setItem(KEY + url, JSON.stringify({ at: Date.now(), total: t })); } catch (e) {}
        return t;
      })
      .catch(function () { return null; });
  }
  function run() {
    var els = document.querySelectorAll('[data-ff-pack-url]:not([data-ff-pack-done])');
    if (!els.length) { return; }
    var byUrl = {};
    Array.prototype.forEach.call(els, function (el) {
      var u = el.getAttribute('data-ff-pack-url');
      (byUrl[u] = byUrl[u] || []).push(el);
    });
    var urls = Object.keys(byUrl);
    function show(u) {
      return packFrom(u).then(function (t) {
        byUrl[u].forEach(function (el) {
          // If the price could not be worked out, the stored price stays and is simply shown.
          if (t !== null) { el.textContent = 'From ' + money(t) + (el.getAttribute('data-ff-pack-suffix') || ''); }
          el.setAttribute('data-ff-pack-done', '');
        });
      });
    }
    // One pack first, so a copied theme only has to look up the section id once; then the rest together.
    show(urls[0]).then(function () { urls.slice(1).forEach(show); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  // Collection filters and "load more" swap the product grid without a page load.
  document.addEventListener('shopify:section:load', run);
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      for (var j = 0; j < m[i].addedNodes.length; j++) {
        var n = m[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('[data-ff-pack-url]') || n.querySelector && n.querySelector('[data-ff-pack-url]:not([data-ff-pack-done])'))) { run(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
